import { Button, Divider, Select } from "antd";
import { LabelledElement } from ".";

export const LabelledSelect = ({
    label = "Select",
    type = "text",
    onChange = () => { },
    onSearch = () => { },
    addable = false,
    onAddNew = () => { },
    ...props
}) => (
    <div style={{ width: "100%" }}>
        <LabelledElement label={label} type={type}>
            <Select
                showSearch
                variant="filled"
                style={{ width: "100%" }}
                optionFilterProp="label"
                onChange={onChange}
                onSearch={onSearch}
                popupRender={(menu) => (
                    <div>
                        {menu}
                        {addable && (
                            <div className="mt-2">
                                <Divider style={{ margin: '0' }} />
                                <Button
                                    block
                                    type="text"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onAddNew();
                                    }}
                                    className="mt-2">
                                    {`Add New ${label}`}
                                </Button>
                            </div>
                        )}
                    </div>
                )}
                onInputKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                    if (e.key === "Escape") {
                        e.target.blur();
                    }
                    if (e.key === "Tab") {
                        e.stopPropagation();
                    }
                }}
                {...props}
            />
        </LabelledElement>
    </div>
);
